import { useState } from 'react';
import { IonButton, IonIcon, IonPopover, IonList, IonItem, IonLabel } from '@ionic/react';
import { createOutline, ellipsisVertical, trashOutline } from 'ionicons/icons';

interface PostActionsMenuProps {
  /** Whether the post is still within its edit window (owner-only Editar action). */
  canEdit: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

// Owner-only actions for a post on the detail screen. When the post can still be
// edited we show a ⋮ button opening a small popover with Editar + Eliminar;
// otherwise only Eliminar applies, so we render a single delete button (no menu).
export const PostActionsMenu = ({ canEdit, onEdit, onDelete }: PostActionsMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [event, setEvent] = useState<MouseEvent | undefined>(undefined);

  const openMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setEvent(e.nativeEvent);
    setIsOpen(true);
  };

  const handleEdit = () => {
    setIsOpen(false);
    onEdit();
  };

  const handleDelete = () => {
    setIsOpen(false);
    onDelete();
  };

  if (!canEdit) {
    return (
      <IonButton
        fill="clear"
        size="small"
        color="danger"
        aria-label="Eliminar publicación"
        onClick={onDelete}
      >
        <IonIcon slot="icon-only" icon={trashOutline} />
      </IonButton>
    );
  }

  return (
    <>
      <IonButton
        fill="clear"
        size="small"
        aria-label="Más acciones"
        onClick={openMenu}
      >
        <IonIcon slot="icon-only" icon={ellipsisVertical} />
      </IonButton>
      <IonPopover
        isOpen={isOpen}
        event={event}
        onDidDismiss={() => setIsOpen(false)}
        showBackdrop
        backdropDismiss
      >
        {/* A fixed icon size keeps both start icons the same width, so the two
            labels line up at the same left offset. */}
        <IonList>
          <IonItem button detail={false} aria-label="Editar publicación" onClick={handleEdit}>
            <IonIcon slot="start" icon={createOutline} style={{ fontSize: 20 }} />
            <IonLabel>Editar</IonLabel>
          </IonItem>
          <IonItem button detail={false} lines="none" aria-label="Eliminar publicación" onClick={handleDelete}>
            <IonIcon slot="start" icon={trashOutline} color="danger" style={{ fontSize: 20 }} />
            <IonLabel color="danger">Eliminar</IonLabel>
          </IonItem>
        </IonList>
      </IonPopover>
    </>
  );
};
